<script setup lang="ts">
import { computed } from 'vue'
import { LoaderCircle } from '@lucide/vue'

import { cn } from '@/shared/lib/cn'

interface Props {
  size?: 'sm' | 'md' | 'lg'
  label?: string
}

const props = withDefaults(defineProps<Props>(), { size: 'md', label: 'Loading' })

const sizeClass = computed(() => ({ sm: 'size-4', md: 'size-6', lg: 'size-8' })[props.size])
</script>

<template>
  <LoaderCircle
    :class="cn('animate-spin text-muted-foreground', sizeClass)"
    role="status"
    :aria-label="label"
  />
</template>
